import DatePickerContainer from "../../../UI/DatePicker/DatePickerContainer";
import { format, parseISO, subDays } from "date-fns";
import { getCurrentDateString } from "../../../utils/formatters/dateFormatter";
import { getUserSelectedDateOption } from "./customDateUtils";
import useToDateFiltersLocalState from "./useToDateFiltersLocalState";

export function getDefaultSingleDay() {
  const date = parseISO(getCurrentDateString());
  return format(subDays(date, 1), "yyyy-MM-dd");
}

export default function SingleDay(props) {
  const {
    Container,
    recentMonthsChange,
    theme,
    activeTabUuid,
    selectedDateType,
    saveStickyDatesToStore,
    dateFiltersConfig,
    dateConfig,
    recentSelectedDatePreset,
  } = props;

  const { localState, setLocalState } = useToDateFiltersLocalState(
    dateConfig.tabChanged,
    { from: getDefaultSingleDay() }
  );

  const { from } = getUserSelectedDateOption(
    dateFiltersConfig,
    activeTabUuid
  ) ?? { ...localState, ...(recentSelectedDatePreset ?? {}) };

  function setSingleDay(e) {
    const day = e.target.value;
    recentMonthsChange({ from: day, to: day });
    saveStickyDatesToStore(selectedDateType, { from: day, to: day });
    setLocalState({ from: day });
  }

  return (
    <Container>
      <DatePickerContainer menuPrimary={theme.menuPrimary}>
        <input
          type="date"
          onChange={setSingleDay}
          value={from}
          data-cy="single-day-input"
        />
      </DatePickerContainer>
    </Container>
  );
}
